import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators/map";
import { Md5 } from "ts-md5";

/**
 *  Service de gestion de l'authentification (login/logout) et a l'initialisation des services utilisés dans l'application
 */
@Injectable()
export class AuthenticationService {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /** Session en cours */
  public h_currentUser: any;

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    //Cas spécifique, car service accessible depuis la page register
    //donc sans être logué. Et sur rechargement (F5), le appSettings
    //est chargé après la construction de ce service
    if (this.s_global.pathAPI === "pathAPI") {
      s_appsettings.proc_getSettings().subscribe(settings => {
        this.s_global.pathAPI = settings.pathAPI;
        this.s_global.pathDocEcoltex = settings.pathDocEcoltex;
        this.s_global.pathDocEbizHB = settings.pathDocEbizHB;
        this.w_baseUrl = this.s_global.pathAPI + "/authentification";
      });
    } else this.w_baseUrl = this.s_global.pathAPI + "/authentification";
  }

  /**
   * Fonction de login
   * Parametres : nom du compte, mot de passe [, ID du chef de grappe auquel le compte doit se connecter]
   * Retour : json avec token, raison sociale, flag de validation de CDG
   *
   */
  public proc_login(
    w_username: string,
    w_password: string,
    w_tiersIdcdg: string
  ): Observable<any> {
    let w_url: string = `${this.w_baseUrl}/login`;
    if (w_tiersIdcdg != null && w_tiersIdcdg !== "")
      w_url = `${this.w_baseUrl}/login/${w_tiersIdcdg}`;

    return this.http
      .post(
        w_url,
        { username: w_username, password: Md5.hashStr(w_password) },
        this.s_appsettings.proc_getHeaders()
      )
      .pipe(
        map((response: any) => {
          //On enregistre le user en local afin de garder sa session coté client
          if (response && response.token)
            localStorage.setItem("currentUser", JSON.stringify(response));
          return response;
        })
      );
  }

  /**
   * Fonction de recuperation du mot de passe (mot de passe perdu)
   * Parametres : nom du compte, adresse mail liée a ce compte
   *
   */
  public proc_recupMDP(username: string, mail: string): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/recupMDP`,
      JSON.stringify({
        username: username,
        mail: mail,
        msg_titre: this.s_appsettings.proc_getTraduction(
          "API_authentification.mail_titre_updateMDP"
        ),
        msg_lig1: this.s_appsettings.proc_getTraduction(
          "API_authentification.mail_msg_updateMDP_1"
        ),
        msg_lig2: this.s_appsettings.proc_getTraduction(
          "API_authentification.mail_msg_updateMDP_2"
        )
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   *  Fonction de déconnexion et de suppression de la session locale
   *
   */
  public proc_logout() {
    this.h_currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (this.h_currentUser != null)
      this.http
        .post(
          `${this.w_baseUrl}/logout`,
          "",
          this.s_appsettings.proc_getHeaders()
        )
        .subscribe();

    localStorage.removeItem("currentUser");
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/authentication.service.ts